import UploadFilesButton from "./UploadFilesButton";
import MoreButton from "./MoreButton";
import { Link } from "../../../../design/link";
import { Subtask } from "../../../../models/Subtask";
import CompleteSubtaskAlert from "../../../../components/CompleteSubtaskAlert";
import { useState } from "react";
import { Button } from "../../../../design/button";
import { EyeIcon } from "@heroicons/react/20/solid";
import { Subheading } from "../../../../design/heading";

interface DiscoveryRequestSubtaskListItemProps {
  subtask: Subtask;
}

const DiscoveryRequestSubtaskListItem: React.FC<
  DiscoveryRequestSubtaskListItemProps
> = ({ subtask }) => {
  const [isCompleteOpen, setIsCompleteOpen] = useState(false);
  return (
    <>
      <CompleteSubtaskAlert
        isOpen={isCompleteOpen}
        setIsOpen={setIsCompleteOpen}
        subtaskId={subtask._id}
      />
      <li
        key={subtask._id}
        className={`flex items-center justify-between px-4 py-2 rounded-md ${subtask.status === "complete" ? `bg-green-300` : `bg-white`}`}
      >
        <Link
          href={`/subtask/${subtask._id}`}
          className={`text-sm ${
            subtask.status === "complete"
              ? "line-through text-gray-400"
              : "text-gray-700"
          }`}
        >
          <Subheading>{subtask.title}</Subheading>
        </Link>
        <div className="flex items-center gap-2">
          {subtask.status !== "complete" && (
            <UploadFilesButton
              subtaskId={subtask._id}
              onFilesUploaded={() => setIsCompleteOpen(true)}
            />
          )}
          {subtask.status === "complete" && (
            <Button href={`/subtask/${subtask._id}`}>
              <EyeIcon />
            </Button>
          )}
        </div>
      </li>
    </>
  );
};

export default DiscoveryRequestSubtaskListItem;
